import { render, staticRenderFns } from "./MobileHelloWorld.vue?vue&type=template&id=1347ca83&scoped=true"
import script from "./MobileHelloWorld.vue?vue&type=script&lang=js"
export * from "./MobileHelloWorld.vue?vue&type=script&lang=js"
import style0 from "./MobileHelloWorld.vue?vue&type=style&index=0&id=1347ca83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347ca83",
  null
  
)

export default component.exports